import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
    scrollContainer: {
        position: 'relative',

        width: '100%',
    },
    shortcuts: {
        display: 'grid',
        gridTemplate: 'auto / repeat(5, 1fr)',
        gridAutoFlow: 'row',
        gap: theme.spacing(0.5),
        width: 'auto',
        margin: '0 auto',
    },
    shortcut: {
        minHeight: theme.spacing(6),
        margin: theme.spacing(0.5),
        marginBottom: theme.spacing(0.5),

        border: `1px solid ${theme.customKeyboard.key.border.default}`,

        textTransform: 'none',

        '&&:disabled': {
            backgroundColor: theme.customKeyboard.key.background.disabled,
        },

        '&&[nth-last-child]': {
            borderRight: 'none',
        },
    },
    text: {
        whiteSpace: 'break-spaces',
        textWrap: 'balance',
        wordBreak: 'break-word',
        color: theme.customKeyboard.key.text.default,
    },
}));
